module.exports = __webpack_public_path__ + "img/card_empty.6dccd252.svg";